import React, { Component } from "react";
import api from "../../../Environment";
import {
  REFRESH_INTERVAL_MS,
  normalizeAnnouncement,
  isDismissible,
  dismissalKey,
  liveRegionProps,
} from "./globalAnnouncement";
import "./GlobalAnnouncementBanner.css";

// Shared across layout remounts so route changes do not refetch within the interval.
const cache = { data: null, fetchedAt: 0, pending: null };

function loadAnnouncement(force) {
  const fresh =
    cache.fetchedAt && Date.now() - cache.fetchedAt < REFRESH_INTERVAL_MS;
  if (!force && fresh) {
    return Promise.resolve(cache.data);
  }
  if (cache.pending) {
    return cache.pending;
  }
  cache.pending = api
    .postMethod("global_announcement", {})
    .then(function (response) {
      const body = response && response.data;
      cache.data =
        body && body.success === true ? normalizeAnnouncement(body.data) : null;
      cache.fetchedAt = Date.now();
      cache.pending = null;
      return cache.data;
    })
    .catch(function () {
      cache.fetchedAt = Date.now();
      cache.pending = null;
      return cache.data;
    });
  return cache.pending;
}

class GlobalAnnouncementBanner extends Component {
  state = {
    announcement: cache.data,
    dismissedVersion: "",
  };

  componentDidMount() {
    this.mounted = true;
    this.refresh(false);
    this.timer = setInterval(() => this.refresh(true), REFRESH_INTERVAL_MS);
  }

  componentWillUnmount() {
    this.mounted = false;
    clearInterval(this.timer);
  }

  refresh(force) {
    loadAnnouncement(force).then((announcement) => {
      if (this.mounted) {
        this.setState({ announcement: announcement });
      }
    });
  }

  isDismissed(announcement) {
    if (!isDismissible(announcement)) {
      return false;
    }
    if (this.state.dismissedVersion === announcement.version) {
      return true;
    }
    try {
      return localStorage.getItem(dismissalKey(announcement.version)) === "1";
    } catch (e) {
      return false;
    }
  }

  dismiss = () => {
    const announcement = this.state.announcement;
    if (!isDismissible(announcement)) {
      return;
    }
    try {
      localStorage.setItem(dismissalKey(announcement.version), "1");
    } catch (e) {
      // Storage unavailable: dismissal lasts for this page view only.
    }
    this.setState({ dismissedVersion: announcement.version });
  };

  render() {
    const announcement = this.state.announcement;
    if (!announcement || this.isDismissed(announcement)) {
      return null;
    }

    return (
      <div
        className="pp-global-announcement"
        style={{
          backgroundColor: announcement.backgroundColor,
          color: announcement.textColor,
        }}
        {...liveRegionProps(announcement)}
      >
        <div className="pp-global-announcement__inner">
          <span
            className="pp-global-announcement__icon"
            key={announcement.type}
            aria-hidden="true"
          >
            <i className={announcement.icon} />
          </span>
          <div className="pp-global-announcement__body">
            <strong className="pp-global-announcement__label">
              {announcement.label}
            </strong>
            <p className="pp-global-announcement__message">
              {announcement.message}
            </p>
          </div>
          {isDismissible(announcement) ? (
            <button
              type="button"
              className="pp-global-announcement__dismiss"
              aria-label="Dismiss announcement"
              onClick={this.dismiss}
            >
              &times;
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default GlobalAnnouncementBanner;
